// auth.js
import { getAuth } from 'firebase/auth';
import { initFb, stRef, uploadBytes, getDownloadURL } from './config.js';
import {
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
} from 'firebase/auth';
import { i18n } from '../custom/translator.js';
import { getStorage } from 'firebase/storage';
import { loadCountries, loadLangsList } from './common.js';
import { getLanguage } from './global.js';
import { get, getDatabase, ref } from 'firebase/database';
const authView = document.getElementById('auth-view');
const protectedView = document.getElementById('protected-view');
const authForm = document.getElementById('auth-form');
const emailInput = document.getElementById('email');
const passwordInput = document.getElementById('password');
const formTitle = document.getElementById('form-title');
const formSubtitle = document.getElementById('form-subtitle');
const submitBtn = document.getElementById('submit-btn');
const switchModeBtn = document.getElementById('switch-mode');
const toggleWrapper = document.getElementById('toggle-wrapper');
const toggleInfo = document.getElementById('toggle-info');
const errorMessage = document.getElementById('error-message');
const userDisplayEmail = document.getElementById('user-display-email');
const logoutBtn = document.getElementById('logout-btn');

const signupFields = document.getElementById('signup-only-fields');
const nameInput = document.getElementById('display-name');
const fileInput = document.getElementById('profile-pic');
const countryInput = document.getElementById('country');
const langInput = document.getElementById('language');
const previewContainer = document.getElementById('preview-container');
const imagePreview = document.getElementById('image-preview');
let lang;
let auth;
let isLoginMode = true;
let activeLs = [];
let isFinishRegistration = false;
let dbRef;

$('document').ready(function () {
  //initCampScroll();
  lang = getLanguage();
  initAuthLs();
  initLs();
});
function initAuthLs() {
  initFb();
  dbRef = getDatabase();
  auth = getAuth();
  auth.languageCode = lang;
  // 1. Session Observer Sync
  let unsubAuth = onAuthStateChanged(auth, (user) => {
    if (user) {
      verifyUserData(user);
    } else {
      authView.classList.remove('hidden');
      protectedView.classList.add('hidden');
    }
  });
  activeLs.push(unsubAuth);
}

async function verifyUserData(user) {
  //check if user info is registered in the database
  const dbUser = ref(dbRef, `user/${user.uid}`);
  const snapshot = await get(dbUser);
  if (!snapshot.exists()) {
    //show registration form with email pre-filled and no password required and hidden
    emailInput.value = user.email;
    passwordInput.classList.add('hidden');
    passwordInput.removeAttribute('required');
    isFinishRegistration = true;
    isLoginMode = false;
    switchModeBtn.click();
  } else {
    isFinishRegistration = false;
    //check if redirect exists in the URL and handle it accordingly
    authForm.reset();
    const urlParams = new URLSearchParams(window.location.search);
    const redirect =
      urlParams.get('redirect') ||
      sessionStorage.getItem('auth_redirect_target') ||
      '/portal.html';
    sessionStorage.removeItem('auth_redirect_target');
    window.location.href = redirect;

    //userDisplayEmail.textContent = user.email;
    //authView.classList.add('hidden');
    //protectedView.classList.remove('hidden');
  }
  hideError();
}
async function initLs() {
  console.log('auth lang selected:', lang);
  loadCountries(lang, countryInput);
  loadLangsList(lang, langInput);
  window.addEventListener('beforeunload', () => {
    activeLs.forEach((stopLs) => {
      stopLs();
    });
  });
  const passwordToggleBtn = document.getElementById('password-toggle-btn');

  passwordToggleBtn.addEventListener('click', () => {
    // Read the current mask setting state
    const currentType = passwordInput.getAttribute('type');

    if (currentType === 'password') {
      // Unmask the text input view
      passwordInput.setAttribute('type', 'text');
      passwordToggleBtn.classList = 'fa-solid fa-eye-slash'; // Shifting face icon placeholder
      passwordToggleBtn.setAttribute(
        'data-i18n-attr',
        '{"aria-label": "hide_password","title": "hide_password"}',
      );
      i18n.translatePage(passwordToggleBtn);
      passwordToggleBtn.setAttribute('aria-label', 'Hide Password');
    } else {
      // Mask the text input view
      passwordInput.setAttribute('type', 'password');
      passwordToggleBtn.classList = 'fa-solid fa-eye'; // Standard eye icon placeholder
      passwordToggleBtn.setAttribute(
        'data-i18n-attr',
        '{"aria-label": "show_password","title": "show_password"}',
      );
      i18n.translatePage(passwordToggleBtn);
      passwordToggleBtn.setAttribute('aria-label', 'Show Password');
    }

    // Retain input cursor engagement after clicking the icon tag
    passwordInput.focus();
  });
  // 1. Listen for file selection changes
  fileInput.addEventListener('change', function () {
    const file = this.files[0];

    if (file) {
      const reader = new FileReader();

      // When the file is completely read, update the image element source
      reader.addEventListener('load', function () {
        imagePreview.setAttribute('src', this.result);
        previewContainer.classList.remove('hidden');
      });

      // Convert the image file into a temporary data URL string
      reader.readAsDataURL(file);
    } else {
      // Clear preview if user cancels selection
      clearPreview();
    }
  });

  // 2. Interface Mode Translation Handler
  // 3. Update your existing switchModeBtn event listener
  switchModeBtn.addEventListener('click', () => {
    isLoginMode = !isLoginMode;
    hideError();
    clearPreview(); // <-- Clear the preview when toggling between Login and Sign Up
    //authForm.reset(); // Clear form fields
    emailInput.value = '';
    passwordInput.value = '';
    if (isLoginMode) {
      if (isFinishRegistration) {
        //sign out
        isFinishRegistration = false;
        logoutBtn.click();
      }
      formTitle.setAttribute('data-i18n', 'access_account');
      submitBtn.setAttribute('data-i18n', 'sign_in');
      i18n.translatePage(formTitle);
      i18n.translatePage(submitBtn);
      signupFields.classList.add('hidden');

      nameInput.removeAttribute('required');
      fileInput.removeAttribute('required');
      countryInput.removeAttribute('required');
      langInput.removeAttribute('required');
      toggleInfo.setAttribute('data-i18n', 'no_account');
      switchModeBtn.setAttribute('data-i18n', 'sign_up');
      toggleInfo.textContent = i18n.t('no_account');
      switchModeBtn.textContent = i18n.t('sign_up');
      // 🎯 Focus the email field on the Login screen
      emailInput.focus();
    } else {
      formTitle.setAttribute(
        'data-i18n',
        isFinishRegistration ? 'finish_registration' : 'create_account',
      );
      submitBtn.setAttribute(
        'data-i18n',
        isFinishRegistration ? 'finish_registration' : 'sign_up',
      );
      i18n.translatePage(formTitle);
      i18n.translatePage(submitBtn);
      signupFields.classList.remove('hidden');

      nameInput.setAttribute('required', '');
      fileInput.setAttribute('required', '');
      countryInput.setAttribute('required', '');
      langInput.setAttribute('required', '');
      toggleInfo.setAttribute(
        'data-i18n',
        isFinishRegistration ? 'change_account' : 'already_account',
      );
      switchModeBtn.setAttribute(
        'data-i18n',
        isFinishRegistration ? 'logout' : 'login',
      );
      toggleInfo.textContent = i18n.t(
        isFinishRegistration ? 'change_account' : 'already_account',
      );
      switchModeBtn.textContent = i18n.t(
        isFinishRegistration ? 'logout' : 'login',
      );

      // 🎯 Focus the name field on the Registration screen
      nameInput.focus();
    }
    // document
    //   .getElementById('switch-mode')
    //   .addEventListener('click', () => switchModeBtn.click());
  });

  // 3. Execution Processing Request Lifecycle
  authForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    hideError();

    const email = emailInput.value.trim();
    const password = passwordInput.value;

    try {
      if (isLoginMode) {
        await signInWithEmailAndPassword(auth, email, password);
      } else {
        // A. Create native authentication profile
        let user;
        if (isFinishRegistration) {
          user = auth.currentUser;
          isFinishRegistration = false;
        } else {
          const userCredential = await createUserWithEmailAndPassword(
            auth,
            email,
            password,
          );
          user = userCredential.user;
        }

        // B. Upload file attachment to Firebase Storage bucket
        const file = fileInput.files[0];
        const fileRef = storageRef(storage, `profile/${user.uid}`);

        const uploadSnapshot = await uploadBytes(fileRef, file);
        const photoURL = await getDownloadURL(uploadSnapshot.ref);

        // C. Sync name and photo attributes directly to Firebase Auth Profile
        await updateProfile(user, {
          displayName: nameInput.value.trim(),
          photoURL: photoURL,
        });

        // D. Save profile record down into the Realtime Database JSON path
        const dbUser = ref(dbRef, `user/${user.uid}`);
        await set(dbUser, {
          name: nameInput.value.trim(),
          date: new Date().getTime(),
          country: countryInput.value,
          lang: langInput.value,
          imgUrl: photoURL,
          id: user.uid,
        });
      }
    } catch (error) {
      displayError(i18n.t(error.code) || i18n.t('def_error'));
    }
  });

  // 4. Session Disconnect Link
  logoutBtn.addEventListener('click', async () => {
    try {
      await signOut(auth);
    } catch (error) {
      displayError(i18n.t('logout_error'));
    }
  });
}
// 2. Clear preview helper function
function clearPreview() {
  imagePreview.setAttribute('src', '');
  previewContainer.classList.add('hidden');
}
function displayError(message) {
  errorMessage.textContent = message; //.replace('Firebase: ', '');
  errorMessage.style.display = 'block';
}

function hideError() {
  errorMessage.textContent = '';
  errorMessage.style.display = 'none';
}
